export const version: string = '2.3.0';
export const dbVersion: number = 4;
